import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NormeSpaMonisticoFieldValidators } from './validators/norme-spa-monistico.field-validators';
import { NormeSpaMonisticoWarningsService } from './warnings/norme-spa-monistico.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [NormeSpaMonisticoFieldValidators, NormeSpaMonisticoWarningsService],
})
export class NormeSpaMonisticoFormModule {}
